import _toConsumableArray from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { modifierPhases } from '../enums';
// source: https://stackoverflow.com/questions/49875255
/**
 * @param modifiers
 */
function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  // On visiting object, check for its dependencies and visit them recursively
  /**
   * @param modifier
   */
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(_toConsumableArray(modifier.requires || []), _toConsumableArray(modifier.requiresIfExists || []));
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
/**
 * @param modifiers
 */
export default function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers);
  // order based on phase
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}